$(function () {

// -----------------------------
//  Video Replace
// -----------------------------
    $('.video-box i').click(function () {
        var video = '<iframe allowfullscreen src="' + $(this).attr('data-video') + '"></iframe>';
        $(this).replaceWith(video);
    });

});


// WEBPACK FOOTER //
// ./js/parts/video.js